import { render } from "./NotUsableChoicesTable.vue?vue&type=template&id=2f09ebc4&scoped=true"
import script from "./NotUsableChoicesTable.vue?vue&type=script&lang=js"
export * from "./NotUsableChoicesTable.vue?vue&type=script&lang=js"

import "./NotUsableChoicesTable.vue?vue&type=style&index=0&id=2f09ebc4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f09ebc4"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTh,QTable,QTd,QIcon});
